<template>
  <div id="app" class="wrapper">
    <!-- <img src="./assets/logo.png"> -->
    <v-header />

    <div :class="['box-wrapper', { f_error, loading: isLoading, error: isError, success: isSuccess }]">
      <div class="box">
        <div class="box-loading" v-if="isLoading"></div>
        <div class="box-header">
          {{ $t('header') }}
        </div>
        <div class="input-wrapper">
          <div class="input">
            <input type="text"
              autocomplete="off"
              maxlength="42"
              :class="{ notEmpty: wallet }"
              @keyup="inputWallet"
              @keyup.delete="walletReset"
              :disabled="disabled"
              v-model="wallet"
            >
            <div class="input-placeholder">{{ $t('input.placeholder') }}</div>
          </div>
        </div>
        <div class="box-footer" v-if="err.show">
          <div class="input-error">
            <p>{{ $t(err.select || 'Internal Server Error') }}</p>
          </div>
        </div>
        <div class="box-footer" v-else>
          <div v-if="isWithdraw">
            <div class="box-calculate">
              <p>{{ $t('divident.text') }} <span>{{ checkAmount ? full_amount : amount }} ETH</span></p>
              <p v-if="checkAmount">{{ $t('min') }} 0.000001</p>
            </div>
            <div class="input-action" v-if="!checkAmount">
              <button type="button" class="btn" @click="getConfirm">
                {{ $t('divident.withdraw') }}
              </button>
            </div>
          </div>
          <div v-if="isSuccess">
            <div class="box-calculate">
              {{ $t('success') }}
            </div>
            <div class="input-action">
              <button type="button" class="btn" @click="walletReset">
                {{ $t('back') }}
              </button>
            </div>
          </div>
          <div v-if="isConfirm">
            <div class="box-calculate">
              <p>{{ $t('divident.text') }} <span>{{ amount }} ETH</span></p>
            </div>
            <div class="input-action input-inline">
              <button type="button" class="btn btn-cancel" @click="cancelWithdraw">
                {{ $t('cancel') }}
              </button>
              <button type="button" class="btn btn-confirm" @click="confirmWithdraw">
                {{ $t('confirm') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="footer">
      {{ $t('footer') }} <a href="https://help.cpayfoundation.com">{{ $t('menu.faq') }}</a>
    </footer>
  </div>
</template>

<style lang="scss" src="@/assets/scss/app.scss"></style>

<script>
// import Raven from 'raven-js'
import VHeader from '@/components/Header'

export default {
  name: 'App',
  components: {
    VHeader
  },
  data () {
    return {
      isFetch: false,
      min_amount: '0.000001',
      wallet: '',
      amount: 0,
      full_amount: 0,
      f_error: false,
      isError: false,
      disabled: false,
      isSuccess: false,
      isLoading: false,
      isConfirm: false,
      isWithdraw: false,
      err: {
        show: false,
        select: 'ERROR_INVALID_WALLET_ADDRESS'
      }
    }
  },
  computed: {
    checkAmount () {
      return this.full_amount <= this.min_amount
    },
    checkInputETH () {
      return !!this.wallet.length && /^0x[0-9a-z]{40}$/i.test(this.wallet)
    },
    checkWallet () {
      return !this.checkInputETH && this.wallet.length === 42
    }
  },
  methods: {
    initAnalytics () {
      /* eslint-disable */
      !function() {
        var analytics = window.analytics = window.analytics || []; if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice."); else {
          analytics.invoked = !0; analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on"]; analytics.factory = function(t) { return function() { var e = Array.prototype.slice.call(arguments); e.unshift(t); analytics.push(e); return analytics } }; for (var t = 0; t < analytics.methods.length; t++) { var e = analytics.methods[t]; analytics[e] = analytics.factory(e) } analytics.load = function(t) { var e = document.createElement("script"); e.type = "text/javascript"; e.async = !0; e.src = ("https:" === document.location.protocol ? "https://" : "http://") + "cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js"; var n = document.getElementsByTagName("script")[0]; n.parentNode.insertBefore(e, n) }; analytics.SNIPPET_VERSION = "4.0.0";
          analytics.load("nKgwAJsI7JcEGS4dTq0ojGMaEuKDS5VE");
          analytics.page('Dividends ICO', 'Opened Page Dividends ICO');
        }
      }();
      /* eslint-enable */
    },
    pushEventAnalytics (e) {
      if (this.$config.isProd) {
        window.analytics.track(e, {
          category: 'Dividends ICO',
          amount_eth: this.full_amount,
          address_eth: this.wallet
        })
      }
    },
    dataReset () {
      this.f_error = false
      this.isError = false
      this.err.show = false
      this.disabled = false
      this.isSuccess = false
      this.isLoading = false
      this.isConfirm = false
      this.isWithdraw = false
    },
    walletReset () {
      this.wallet = ''
      this.dataReset()
      this.isFetch = false
    },
    setError (error) {
      this.dataReset()

      this.isError = true
      this.err.show = true
      this.err.select = error
    },
    inputWallet ($event) {
      if (this.isFetch) return

      this.wallet = $event.target.value.replace(/[^0-9a-z]/gi, '').toLowerCase()

      this.err.select = 'ERROR_INVALID_WALLET_ADDRESS'
      this.err.show = !this.checkInputETH && this.wallet.length === 42
      if (this.wallet.length !== 42) return
      if (!this.checkInputETH) {
        this.f_error = true
        return
      }

      this.isLoading = true
      this.isFetch = true
      this.$http.post('public/calculate', {
        address: this.wallet
      }).then(({ body: { result } }) => {
        this.amount = result.amount
        this.full_amount = result.full_amount

        this.dataReset()
        this.f_error = this.checkAmount
        this.isWithdraw = true

        this.pushEventAnalytics('Specified Eth adress')
      }, ({ body: { error } }) => this.setError(error))
    },
    getConfirm () {
      if (!this.checkInputETH) {
        this.err.select = 'ERROR_INVALID_WALLET_ADDRESS'
        this.err.show = true
        return
      }

      this.dataReset()
      this.disabled = true
      this.isConfirm = true

      this.pushEventAnalytics('Clicked Withdraw dividend')
    },
    confirmWithdraw () {
      if (!this.checkInputETH) {
        this.err.select = 'ERROR_INVALID_WALLET_ADDRESS'
        this.err.show = true
        return
      }

      this.dataReset()
      this.disabled = true
      this.isLoading = true

      this.$http.post('public/withdrawal', {
        address: this.wallet
      }).then(({ body: { result } }) => {
        this.isSuccess = true
        this.isLoading = false

        this.pushEventAnalytics('Clicked Confirm Withdraw dividend')
      }, ({ body: { error } }) => this.setError(error))
    },
    cancelWithdraw () {
      this.pushEventAnalytics('Clicked Cancel Withdraw dividend')
      this.walletReset()
    }
  },
  beforeMount () {
    if (this.$config.isProd) {
      this.initAnalytics()
      window.analytics.ready(() => {
        window.Intercom('shutdown')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue